import { SvgIconProps } from "@mui/material";
import React from "react";

const ApprovalsIcon = (props: SvgIconProps) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="7" height="7" x="3" y="3" rx="2" stroke-width={props.strokeWidth || 2}  fill={"none"} />
            <rect width="7" height="7" x="3" y="14" rx="2" stroke-width={props.strokeWidth || 2}  fill={"none"} />
            <path d="M14 4h7" stroke={props.stroke || "currentColor"} stroke-width={props.strokeWidth || 2} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 9h7" stroke={props.stroke || "currentColor"} stroke-width={props.strokeWidth || 2} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 15h7" stroke={props.stroke || "currentColor"} stroke-width={props.strokeWidth || 2} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 20h7" stroke={props.stroke || "currentColor"} stroke-width={props.strokeWidth || 2} stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default ApprovalsIcon;
